import { render, staticRenderFns } from "./doexam.vue?vue&type=template&id=374868c0&scoped=true"
import script from "./doexam.vue?vue&type=script&lang=js"
export * from "./doexam.vue?vue&type=script&lang=js"
import style0 from "./doexam.vue?vue&type=style&index=0&id=374868c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374868c0",
  null
  
)

export default component.exports